import { getPlantDetail } from '@apis';
import { plantQueryKeys } from '@hooks';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { BaseResponse, Plant } from '@types';
import { AxiosResponse } from 'axios';

type Success = { plant: Plant; status: string };
type NotFound = { plant: null; status: string };

const useGetPlantDetail = (plantId: string): UseQueryResult<Success | NotFound> => {
  return useQuery({
    queryFn: () => getPlantDetail(plantId),
    queryKey: plantQueryKeys.detail(plantId),
    select: (response: AxiosResponse<BaseResponse<Plant[]>>) => {
      const isEmpty = response.data.list.length < 0;
      const plant = isEmpty ? null : response.data.list[0];
      const status = isEmpty ? 'not-found' : 'success';

      return { plant, status };
    },
  });
};

export default useGetPlantDetail;
